import PillarPageLayout from "@/components/PillarPageLayout";
export default function TerroirsViticolesPage() { return <PillarPageLayout slug="terroirs-viticoles" />; }
